import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import ProfileSettingsAccordionItem from '@Pages/ProfileSettings/Components/ProfileSettingsAccordionItem';
import { TextInput } from '@els/els-react--text-input';

function ProfileSettingsInputSection({ name, label, value, title, validate, errorsMessages, onChange, onSave, onClose, onBlur }) {
  const [formErrors, setFormErrors] = useState(null);

  const formValid = useMemo(() => !formErrors, [formErrors]);

  // eslint-disable-next-line no-shadow
  const validateInput = (value) => {
    const { errors, isValid } = validate(value);

    if (isValid) {
      setFormErrors(null);
      return;
    }
    setFormErrors(errors.map((error) => errorsMessages[error]));
  };

  const handleInputChange = (event) => {
    // eslint-disable-next-line no-shadow
    const { value } = event.target;
    onChange(value);
    validateInput(value);
  };

  const handleClose = () => {
    setFormErrors(null);
    onClose();
  };

  const handleBlur = () => {
    onBlur(formErrors);
  };

  return (
    <ProfileSettingsAccordionItem onClose={handleClose} label={label} value={value} onSave={onSave} formValid={formValid} title={title}>
      <TextInput key={name} id={name} name={name} label={label} value={value} onChange={handleInputChange} onBlur={handleBlur}>
        {formErrors && (
          <>
            {formErrors.map((err, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <TextInput.Message key={`${label}-error-messages-${idx}`} id={`${label}-error-messages`} type="error">
                {err}
              </TextInput.Message>
            ))}
          </>
        )}
      </TextInput>
    </ProfileSettingsAccordionItem>
  );
}

ProfileSettingsInputSection.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  errorsMessages: PropTypes.object,
};

export default ProfileSettingsInputSection;
